import classNames from "classnames";
import React from "react";
import Seller from "./Seller";
import Source from "./Source";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels} = props;
    const SellerComp = props.Seller || Seller;
    const SourceComp = props.Source || Source;
    return (hidden || []).indexOf("from") === -1 && <div className={classNames({
        "col-sm-6": (hidden || []).indexOf("to") === -1,
        "col-sm-12": ((hidden || []).indexOf("to") !== -1 || ((hidden || []).indexOf("seller") !== -1 && (hidden || []).indexOf("source") !== -1))
    })}>
        <div className="row form-row">
            <div className={classNames({
                "col-sm-12": ((hidden || []).indexOf("to") === -1 || (hidden || []).indexOf("source") !== -1),
                "col-sm-6": (hidden || []).indexOf("to") !== -1
            })}>
                {<SellerComp {...propsTop} />}
            </div>
            <div className={classNames({
                "col-sm-12": ((hidden || []).indexOf("to") === -1 || (hidden || []).indexOf("seller") !== -1),
                "col-sm-6": (hidden || []).indexOf("to") !== -1
            })}>
                {<SourceComp {...propsTop} />}
            </div>
        </div>
    </div>;
}